/* eslint-disable no-underscore-dangle */
import React, {
	useCallback,
	useContext,
	useEffect,
	useState,
	useRef,
} from 'react';
import Button from '@mui/material/Button';
import { Box } from '@mui/system';
import { makeStyles } from '@mui/styles';
import classesNames from 'classnames';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { ClassSharp } from '@mui/icons-material';
import OpenOccCard from './OpenOccCard';
import { LayerContext } from '../context/LayerContext';

const useStyles = makeStyles({
	card: {
		cursor: 'pointer',
	},
	unSelected: {
		// background: 'grey',
	},
	selected: {
		background: '#ADD8E6',
	},
});

interface SearchResultsProps {
	setParamToDialog: (params: string) => void;
}

export default function SearchResults(props: SearchResultsProps) {
	const { setParamToDialog } = props;
	const classes = useStyles();

	const {
		map,
		allPoints,
		drawedPoints,
		selectedPointIdGlobal,
		setSelectedPointIdGlobal,
		activePark,
		setActivePark,
	} = useContext(LayerContext);

	return (
		<div>
			{drawedPoints.map((x: any, index: any) => (
				// eslint-disable-next-line jsx-a11y/no-static-element-interactions
				<div
					// role="button"
					key={x._id}
					onMouseEnter={() => {
						console.log(x);
						setSelectedPointIdGlobal(x._id);
						setActivePark(null);

						// setActivePark(x);
						// map.flyTo([x.Location.Lat, x.Location.Lon], 13);
					}}
					onClick={() => {
						setActivePark(x);
						console.log(x);
						setSelectedPointIdGlobal(x._id);
						setParamToDialog(x._id)
						map.flyTo([x.Location.Lat, x.Location.Lon], map.getZoom());
					}}
					onKeyDown={(event) => {
						console.log(event.key);
					}}
				>
					<OpenOccCard
						isSelected={selectedPointIdGlobal === x._id}
						// eslint-disable-next-line react/jsx-props-no-spreading
						{...x}
					/>
					{/* <Box
							m={1}
							p={1}
							className={classesNames(
								classes.card,
								selectedPointId === x._id
									? classes.selected
									: classes.unSelected
							)}
						> */}
					{/* <Box>
								<Typography variant="h5" color="initial">
									מס מכרז: {x.MichrazName}
								</Typography>
							</Box>
							<Typography variant="body1" color="initial">
								{x.description}
							</Typography>
							<Typography variant="body1" color="initial">
								{x.type}
							</Typography>
							<Typography variant="body1" color="initial">
								{x.latlng.lat + ',' + x.latlng.lng}
							</Typography>
						</Box> */}
				</div>
			))}
		</div>
	);
}
